import {findInArr} from './utils';

const visibleRange = 5;
const borderRange = (visibleRange - 1) / 2;

export default class Paginator {
  constructor({total, visibleCount, clickCallback, template}) {
    this.clickCallback = clickCallback;
    this.visibleCount = visibleCount;

    this.pgWrapper = document.createElement('div');
    this.pgWrapper.className = 'pgn';
    this.pgWrapper.addEventListener('click', event => this.clickHandler(event));

    if (total) this.init(total)
  };


  init(total = 0, page) {
    this.total = total;
    this.currentPage = page ? page : this.currentPage;
    this.totalPages = Math.ceil(total / this.visibleCount);
    let _tplModel = this.createTemplateModel();

    this.pgWrapper.innerHTML = this.createTemplate(_tplModel);
  }


  get template() {
    return this.pgWrapper;
  }


  createTemplateModel() {
    let template = [this.currentPage - 2, this.currentPage - 1, this.currentPage, this.currentPage + 1, this.currentPage + 2];

    for (let i = 0; i < template.length; i += 1) {
      if (template[i] <= 0 || template[i] > this.totalPages) {
        template.splice(i, 1);
        i--;
      }
    }

    if (template[0] >= 3) template = [1, null].concat(template);

    if (template[1] - 1 === 2) {
      template = [1].concat(template);
    }

    if (template[template.length - 1] + 1 === this.totalPages) {
      template = template.concat([this.totalPages]);
    }

    if (template[template.length - 1] <= this.totalPages - 1) template = template.concat([null, this.totalPages]);

    return template;
  }


  createTemplate(tplModel) {
    let str = '';

    tplModel.forEach(item => {

      if (item === null) {
        str += '<div class="pgn-item pgn-item_disabled">...</div>'
      } else if (item === this.currentPage) {
        str += '<div class="pgn-item pgn-item_active" data-page=' + item + '>' + item + '</div>'
      } else {
        str += '<div class="pgn-item" data-page=' + item + '>' + item + '</div>'
      }

    });

    return str;

  }


  clickHandler(event) {
    if (this.disable) return false;

    const path = event.path || (event.composedPath && event.composedPath());

    if (path) {
      path.forEach(item => {

        if (item.className === 'pgn-item') {
          let num = item.getAttribute('data-page');

          this.clickCallback(+num);
        }

      });
    } else {
      const bubbleFind = (item) => {
        if (item.className === 'pgn-item') {
          let num = item.getAttribute('data-page');

          this.clickCallback(+num);
        } else {
          bubbleFind(item.parentNode);
        }
      };

      bubbleFind(event.target);
    }
  }


  set disable(value) {
    this._disable = value;

    this.pgWrapper.className = this._disable ? 'pgn pgn_disabled' : 'pgn';
  }

  get disable() {
    return this._disable;
  }

}



// WEBPACK FOOTER //
// ./src/desktop/scripts/searchPageComponents/paginator.js